import axios from 'axios';

const getDefaultFaturamento = () => axios.get('/comprador/default/faturamento');
const getDefaultEntrega = () => axios.get('/comprador/default/entrega');

export default {
  getDefaultFaturamento,
  getDefaultEntrega,
};
